import { useMemo } from "react";
import { AiOutlineQuestionCircle } from "react-icons/ai";
import { BsStarFill } from "react-icons/bs";
import { useAppState } from "../../providers/app-state";

const TimeOptionCheckbox = ({ option, children, optionalInfo, onQuestionMarkPress, campaignText, extraOnChange = () => { } }) => {
    const { state, dispatch } = useAppState();

    const isChecked = useMemo(() => {
        return option === state.timeOption
    }, [state.timeOption, option])

    const disabled = useMemo(() => {
        return !!state.timeOption && !isChecked
    }, [state.timeOption, isChecked])

    return (
        <div
            className={`flex flex-row items-center p-4 md:px-4 ${disabled ? "text-skgGray" : "text-skgBlue"} transition-all ease-in-out flex-wrap h-full bg-white`}
        >
            {
                campaignText && (
                    <div
                        className="basis-full text-center flex items-center justify-center space-x-1 text-skgRed"
                    >
                        <BsStarFill
                            size={10}
                        />
                        <p
                            className="text-xs"
                        >
                            {campaignText}
                        </p>
                    </div>
                )
            }
            <div
                className="basis-full flex space-x-3"
            >
                <input
                    id={option}
                    type="checkbox"
                    className={`accent-skgBlue cursor-pointer`}
                    checked={isChecked}
                    disabled={disabled}
                    onChange={() => {
                        extraOnChange();
                        dispatch({
                            key: "timeOption",
                            value: isChecked ? null : option
                        })
                    }} />
                <label
                    htmlFor={option}
                    className={`flex-1 ${disabled ? "text-gray-400" : "text-skgBlue"} cursor-pointer`}
                >
                    {children}
                    <br />
                    <p
                        className="basis-full italic text-xs"
                    >
                        {optionalInfo}
                    </p>
                </label>
                {
                    onQuestionMarkPress && (
                        <div
                            className="cursor-pointer flex items-center"
                            onClick={onQuestionMarkPress}
                        >
                            <AiOutlineQuestionCircle
                                className={`ml-auto inline-block hover:text-red-500 ${campaignText ? "text-white" : "text-skgBlue"}`}
                            />
                        </div>
                    )
                }
            </div>
        </div>
    )
}

export default TimeOptionCheckbox;